//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as React from 'react'
import { ReactElement } from 'react'
import { Typography } from '@mui/material'

import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'

export default function EditTime(props: {
  propName: string
  label: string
  errors: any
  setValue: any
  register: any
  defaultValue: any
  onChange?: (e: Event) => void
}): ReactElement {
  const { propName, label, setValue, register, defaultValue, errors } = props

  React.useEffect(() => {
    register(propName)
  }, [])

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          onChange={(newValue: Dayjs | null) => {
            const v = newValue?.format('YYYY-MM-DD ')
            setValue(propName, v)
          }}
          label={label}
          defaultValue={dayjs(defaultValue)}
        />
      </LocalizationProvider>
      <Typography variant="inherit" color="textSecondary">
        {errors[propName]?.message}
      </Typography>
    </React.Fragment>
  )
}
